import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'
import { TLinkView } from 'core-components/library/richTextEditor/interface/Tlink'

import { ILinkDialogContentProps, LinkSettingsDialogContent } from './LinkSettingsDialogContent'

interface IProps {
  show: boolean
  type: TLinkView
  onClose: () => void
}

export const LinkSettingsDialog = (props: ILinkDialogContentProps & IProps) => {
  const modalTitle = useMemo(() => {
    return props.type === 'button' ? 'Button Settings' : 'Link Settings'
  }, [props.type])

  return (
    <ModalDialog
      title={modalTitle}
      content={() => (
        <LinkSettingsDialogContent
          type={props.type}
          onCancel={props.onCancel}
          onSave={props.onSave}
          link={props.link}
          src={props.src}
        />
      )}
      size={'sm'}
      onClose={props.onClose}
      show={props.show}
    />
  )
}
